// Tutoring shifts come from TA Draft (draft.lmucs.org/dashboard/schedule/calendar) through this
// app's own server-side endpoint, which signs the request (api/_lib/draftApi.js)
export const TUTORING_SHIFTS_API_PATH = '/api/tutoring-shifts'

export const TUTORING_SHIFTS_REFRESH_MS = 60000

// TA Draft's shift times are campus-local
export const CAMPUS_TIME_ZONE = 'America/Los_Angeles'
